/**
 * offcanvas requires jquery and mmenu
 */
export function offcanvas() {
	$("#offcanvas").mmenu({
		extensions: ["theme-dark"]
	});
}
